export default __webpack_public_path__ + "static/media/029-Winter Soldier.d75fcf94.svg";